import React, { useContext, useEffect, useState } from 'react'
import dao from '../../assets/img/dao.png'
import postnord from '../../assets/img/postnord.png'
import gls from '../../assets/img/gls.png'
import bring from '../../assets/img/bring.png'
import axios from 'axios'
import { UserContext } from '../../App'
import { LoadingFull } from '../loading'

const ShippingSettings = () => {

  const token = localStorage.getItem('token')
  const { user } = useContext(UserContext)
  const [carriers, setCarriers] = useState(user.carriers);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  function updateCarriers(newList) {
    axios({
      method: 'post',
      url: '/api/standardCarriers',
      data: {
        'carriers': newList
      },
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then(res => {
    }).catch(error => {
      console.log(error)
    })
  }
  
  function handleToggle(code) {
    setErrorMessage('')
    const newList = [...carriers]
    const carrier = carriers.find(
      a => a.code === code
    )
    carrier.available = !carrier.available
    const available = newList.filter(a => a.available === true)
    if (available.length < 1) {
      setErrorMessage('Du skal som minimum tilbyde at sende med ét firma')
    }
    setCarriers(newList)
    updateCarriers(newList)
  }

  return (
    <div className="w-full flex flex-col gap-y-2 h-full">
      <div className="list-none shadow-lg">
        <div className="px-5 md:px-10 py-5">
          <h2 className="font-semibold text-sm md:text-base">Hvem vil du tilbyde at sende med?</h2>
          {(errorMessage !== '') ? <h2 className="text-sm font-medium text-gray-900 text-red-500">{errorMessage}</h2> : ""}
          <h2 className="text-sm text-gray-700">Kun relevant, hvis du sælger en bog</h2>
        </div>
        {('carriers' in user) ?
          carriers.map((carrier, index) => {
            return (
              <label for={carrier.code} className="px-10 py-5 border border-gray-100 flex justify-between text-xs md:text-base select-none cursor-pointer">
                <div className={"transition-[opacity_0.2s] flex items-center gap-5 " + (carrier.available ? "" : "opacity-50 cursor pointer-events-none")}>
                  <div className="img w-10">
                    <img src={
                      (carrier.code === 'dao') ?
                        dao
                      : (carrier.code === 'pdk') ?
                        postnord
                      : (carrier.code === 'gls') ?
                        gls
                      : (carrier.code === 'bring') ?
                        bring
                      :
                        ""
                    } className="h-full w-full object-contain" />
                  </div>
                  <div className="">
                    <div className="flex gap-2 items-center font-medium flex-wrap-reverse">
                      <p>{carrier.name}</p>
                      {carrier.code === 'dao' || carrier.code === 'bring' ? <div className="text-center text-xs p-[2px] px-2 bg-gradient-to-r from-emerald-600 to-emerald-700 bg-size-200 bg-pos-0 text-white rounded-full">Labelless</div> : <div className="text-center text-xs p-[2px] px-2 bg-gradient-to-r from-neutral-400 to-neutral-500 bg-size-200 bg-pos-0 text-white rounded-full">Kræver printer</div>}
                    </div>
                  </div>
                </div>
                <div className="flex items-center">
                  <input
                          className="h-3.5 w-10 appearance-none rounded-[0.4375rem] bg-neutral-300 after:absolute after:z-[2] after:-mt-[0.1875rem] after:h-5 after:w-5 after:rounded-full after:border-none after:bg-neutral-100 after:shadow-[0_0px_3px_0_rgb(0_0_0_/_7%),_0_2px_2px_0_rgb(0_0_0_/_4%)] after:transition-[background-color_0.2s,transform_0.2s] after:content-[''] checked:bg-primary checked:after:absolute checked:after:z-[2] checked:after:-mt-[3px] checked:after:ml-[1.275rem] checked:after:h-5 checked:after:w-5 checked:after:rounded-full checked:after:border-none checked:after:bg-primary checked:after:shadow-[0_3px_1px_-2px_rgba(0,0,0,0.2),_0_2px_2px_0_rgba(0,0,0,0.14),_0_1px_5px_0_rgba(0,0,0,0.12)] checked:after:transition-[background-color_0.2s,transform_0.2s] checked:after:content-[''] hover:cursor-pointer focus:outline-none focus:ring-0 focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-5 focus:after:w-5 focus:after:rounded-full focus:after:content-[''] checked:bg-emerald-600"
                          type="checkbox"
                          role="switch"
                          name={carrier.code}
                          id={carrier.code}
                          onClick={(e) => handleToggle(carrier.code)}
                          checked={carrier.available} />
                </div>
              </label>
            )
          })
        :
          <LoadingFull />
        }
      </div>
    </div>
  )
}

export default ShippingSettings